// src/libs/agGridConfig.ts
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import { ColDef } from 'ag-grid-community';

// ✅ Required to enable all client-side features like filtering, sorting, pagination
ModuleRegistry.registerModules([AllCommunityModule]);

// ✅ Default config for all columns in PLGrid
export const defaultColDef: ColDef = {
  sortable: true,
  filter: true, 
  resizable: true, 
  flex: 1,
  minWidth: 100,
};
